import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../../box/src";
import { focusOutline } from "../../../theme/src";
import { getLinkStyle, ignoredPropsConfig } from '../style';
export const FakeLink = (_a) => {
    var { enableWrap = false, onClick, styledOnlyOnHover = false } = _a, otherProps = __rest(_a, ["enableWrap", "onClick", "styledOnlyOnHover"]);
    return (_jsx(FakeLinkWrapper, Object.assign({ enableWrap: enableWrap, onClick: onClick, onKeyDown: onClick ? onEnterOrSpacePress(onClick) : undefined, role: "button", styledOnlyOnHover: styledOnlyOnHover }, otherProps)));
};
export default FakeLink;
const FakeLinkWrapper = styled(Box)
    .withConfig(ignoredPropsConfig)
    .attrs((attrs) => (Object.assign({ tabIndex: 0 }, attrs))) `
  ${getLinkStyle};
  ${focusOutline};
`;
//# sourceMappingURL=FakeLink.js.map